import { IconBuilding } from "@tabler/icons-react";
import { Badge, Group, Paper, Stack, Text, ThemeIcon } from "@/components/ui";
import type { OrganizacionEnSolicitud } from "@/lib/types";

/**
 * Banner destacado de la organización del Grupo Financiero que la
 * solicitud derivó automáticamente del RFC receptor del CFDI
 * (decisión 65). Solo se renderiza cuando ya hay `organizacion` definida.
 */
export function BannerOrganizacion({ org }: { org: OrganizacionEnSolicitud }) {
  return (
    <Paper
      padding="md"
      style={{
        borderColor: "var(--color-multiva-300)",
        background: "linear-gradient(135deg, var(--color-multiva-50) 0%, var(--color-card) 100%)",
      }}
    >
      <Group gap="md" wrap="nowrap">
        <ThemeIcon variant="filled" color="multiva" size="lg" radius="md">
          <IconBuilding size={20} stroke={1.6} />
        </ThemeIcon>
        <Stack gap={2} className="min-w-0 flex-1">
          <Text size="xs" c="multiva-700" fw={600} tt="uppercase" className="tracking-wide" style={{ fontSize: 10 }}>
            Organización del Grupo
          </Text>
          <Text fw={600}>{org.nombre}</Text>
          <Group gap={6}>
            <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[11px]">{org.rfc}</code>
            <Badge size="xs" color="multiva">SAP {org.numeroSociedad}</Badge>
          </Group>
        </Stack>
      </Group>
    </Paper>
  );
}
